const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRICE_TIER)
export const apiPriceTiers = {
	fetchPriceTiers: async () => {
		const { data } = await apiCommon<IMealPriceTier[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		return { data: data.map(d => PriceTier(d)) }
	},

	updatePriceTiers: async (payload: IDietPriceTierPayload[]) => {
		const { data } = await apiCommon<IMealPriceTier[]>(`${groupPrefix}`, {
			method: 'POST',
			body: { data: payload },
		})
		return { data: data.map(d => PriceTier(d)) }
	},
}
